import * as React from "react";
import { View } from "./view";
import { useViewModel } from "./viewModel";

export default function Login() {
  const viewModel = useViewModel();
  return <View {...viewModel} />;
}
